/* eslint-disable @typescript-eslint/no-explicit-any */
import dynamic from 'next/dynamic';
import React from 'react';
import SkeletonLoader from '@/components/atoms/skeleton-loader/skeleton-loader';
import { CrossBrandCustomProductListContainerProps } from '@/components/blocks/cross-brand-custom-product-list/cross-brand-custom-product-list.container';
import { ProfileCompanionsContainerProps } from '@/components/blocks/profile-companions/profile-companions.container';
import { ProfileEntryCardContainerProps } from '@/components/blocks/profile-entry-card/profile-entry-card.container';
import { ProfileHeaderContainerProps } from '@/components/blocks/profile-header/profile-header.container';
import { ProfileLoyaltyBenefitsContainerProps } from '@/components/blocks/profile-loyalty-benefits/profile-loyalty-benefits.container';
import { ProfileLoyaltyEntryContainerProps } from '@/components/blocks/profile-loyalty-entry/profile-loyalty-entry.container';
import { ProfileNoLoyaltyWallContainerProps } from '@/components/blocks/profile-no-loyalty-wall/profile-no-loyalty-wall.container';
import { ProfilePastTripsContainerProps } from '@/components/blocks/profile-past-trips/profile-past-trips.container';
import { ProfileTripInvitationContainerProps } from '@/components/blocks/profile-trip-invitation/profile-trip-invitation.container';
import { ProfileUpcomingTripsContainerProps } from '@/components/blocks/profile-upcoming-trips/profile-upcoming-trips.container';
import { ProfileUserConsentsContainerProps } from '@/components/blocks/profile-user-consents/profile-user-consents.container';
import { ProfileUserDeleteContainerProps } from '@/components/blocks/profile-user-delete/profile-user-delete.container';
import { ProfileUserHeaderContainerProps } from '@/components/blocks/profile-user-header/profile-user-header.container';
import { ProfileUserInformationContainerProps } from '@/components/blocks/profile-user-information/profile-user-information.container';
import { TripChecklistContainerProps } from '@/components/blocks/trip-checklist/trip-checklist.container';
import { BannerSliderProps } from '@/components/modules/banner-slider/banner-slider';
import { ComposableContentProps } from '@/components/modules/composable-content/composable-content';
import styles from './profile-module-list.module.scss';

const ModuleLoadingFallback = () => (
  <SkeletonLoader
    className={styles.skeletonLoader}
    height="120px"
    width="100%"
  />
);

const BannerSlider = dynamic(
  () => import('@/components/modules/banner-slider/banner-slider'),
  { loading: ModuleLoadingFallback },
);
const ComposableContent = dynamic(
  () => import('@/components/modules/composable-content/composable-content'),
  { loading: ModuleLoadingFallback },
);
const CrossBrandCustomProductListContainer = dynamic(
  () =>
    import(
      '@/components/blocks/cross-brand-custom-product-list/cross-brand-custom-product-list.container'
    ),
  { loading: ModuleLoadingFallback },
);
const ProfileCompanionsContainer = dynamic(
  () =>
    import(
      '@/components/blocks/profile-companions/profile-companions.container'
    ),
  { loading: ModuleLoadingFallback },
);
const ProfileEntryCardContainer = dynamic(
  () =>
    import(
      '@/components/blocks/profile-entry-card/profile-entry-card.container'
    ),
  { loading: ModuleLoadingFallback },
);
const ProfileHeaderContainer = dynamic(
  () => import('@/components/blocks/profile-header/profile-header.container'),
  { loading: ModuleLoadingFallback },
);
const ProfileLoyaltyEntryContainer = dynamic(
  () =>
    import(
      '@/components/blocks/profile-loyalty-entry/profile-loyalty-entry.container'
    ),
  { loading: ModuleLoadingFallback },
);
const ProfileLoyaltyBenefitsContainer = dynamic(
  () =>
    import(
      '@/components/blocks/profile-loyalty-benefits/profile-loyalty-benefits.container'
    ),
  { loading: ModuleLoadingFallback },
);
const ProfileNoLoyaltyWallContainer = dynamic(
  () =>
    import(
      '@/components/blocks/profile-no-loyalty-wall/profile-no-loyalty-wall.container'
    ),
);
const ProfilePastTripsContainer = dynamic(
  () =>
    import(
      '@/components/blocks/profile-past-trips/profile-past-trips.container'
    ),
  { loading: ModuleLoadingFallback },
);
const ProfileTripInvitationContainer = dynamic(
  () =>
    import(
      '@/components/blocks/profile-trip-invitation/profile-trip-invitation.container'
    ),
  { loading: ModuleLoadingFallback },
);
const ProfileUpcomingTripsContainer = dynamic(
  () =>
    import(
      '@/components/blocks/profile-upcoming-trips/profile-upcoming-trips.container'
    ),
  { loading: ModuleLoadingFallback },
);
const ProfileUserConsentsContainer = dynamic(
  () =>
    import(
      '@/components/blocks/profile-user-consents/profile-user-consents.container'
    ),
  { loading: ModuleLoadingFallback },
);
const ProfileUserDeleteContainer = dynamic(
  () =>
    import(
      '@/components/blocks/profile-user-delete/profile-user-delete.container'
    ),
  { loading: ModuleLoadingFallback },
);
const ProfileUserHeaderContainer = dynamic(
  () =>
    import(
      '@/components/blocks/profile-user-header/profile-user-header.container'
    ),
  { loading: ModuleLoadingFallback },
);
const ProfileUserInformationContainer = dynamic(
  () =>
    import(
      '@/components/blocks/profile-user-information/profile-user-information.container'
    ),
  { loading: ModuleLoadingFallback },
);
const TripChecklistContainer = dynamic(
  () => import('@/components/blocks/trip-checklist/trip-checklist.container'),
  { loading: ModuleLoadingFallback },
);

export type ProfileModule =
  | ({
      $type: 'BannerSliderDto';
    } & BannerSliderProps)
  | ({
      $type: 'ComposableContentModuleDto';
    } & ComposableContentProps)
  | ({
      $type: 'CrossBrandCustomProductListHeadlessModuleDto';
    } & CrossBrandCustomProductListContainerProps)
  | ({
      $type: 'ProfileCompanionsHeadlessModuleDto';
    } & ProfileCompanionsContainerProps)
  | ({
      $type: 'ProfileEntryCardHeadlessModuleDto';
    } & ProfileEntryCardContainerProps)
  | ({
      $type: 'ProfileHeaderHeadlessModuleDto';
    } & ProfileHeaderContainerProps)
  | ({
      $type: 'ProfileLoyaltyBenefitsHeadlessModuleDto';
    } & ProfileLoyaltyBenefitsContainerProps)
  | ({
      $type: 'ProfileLoyaltyEntryHeadlessModuleDto';
    } & ProfileLoyaltyEntryContainerProps)
  | ({
      $type: 'ProfileNoLoyaltyWallHeadlessModuleDto';
    } & ProfileNoLoyaltyWallContainerProps)
  | ({
      $type: 'ProfilePastTripsHeadlessModuleDto';
    } & ProfilePastTripsContainerProps)
  | ({
      $type: 'ProfileTripInvitationHeadlessModuleDto';
    } & ProfileTripInvitationContainerProps)
  | ({
      $type: 'ProfileUpcomingTripsHeadlessModuleDto';
    } & ProfileUpcomingTripsContainerProps)
  | ({
      $type: 'ProfileUserConsentsHeadlessModuleDto';
    } & ProfileUserConsentsContainerProps)
  | ({
      $type: 'ProfileUserDeleteHeadlessModuleDto';
    } & ProfileUserDeleteContainerProps)
  | ({
      $type: 'ProfileUserHeaderHeadlessModuleDto';
    } & ProfileUserHeaderContainerProps)
  | ({
      $type: 'ProfileUserInformationHeadlessModuleDto';
    } & ProfileUserInformationContainerProps)
  | ({
      $type: 'TripChecklistHeadlessModuleDto';
    } & TripChecklistContainerProps);

const ProfileModuleMap: {
  [key in ProfileModule['$type']]: React.ComponentType<any>;
} = {
  BannerSliderDto: BannerSlider,
  ComposableContentModuleDto: ComposableContent,
  CrossBrandCustomProductListHeadlessModuleDto:
    CrossBrandCustomProductListContainer,
  ProfileCompanionsHeadlessModuleDto: ProfileCompanionsContainer,
  ProfileEntryCardHeadlessModuleDto: ProfileEntryCardContainer,
  ProfileHeaderHeadlessModuleDto: ProfileHeaderContainer,
  ProfileLoyaltyBenefitsHeadlessModuleDto: ProfileLoyaltyBenefitsContainer,
  ProfileLoyaltyEntryHeadlessModuleDto: ProfileLoyaltyEntryContainer,
  ProfileNoLoyaltyWallHeadlessModuleDto: ProfileNoLoyaltyWallContainer,
  ProfilePastTripsHeadlessModuleDto: ProfilePastTripsContainer,
  ProfileTripInvitationHeadlessModuleDto: ProfileTripInvitationContainer,
  ProfileUpcomingTripsHeadlessModuleDto: ProfileUpcomingTripsContainer,
  ProfileUserConsentsHeadlessModuleDto: ProfileUserConsentsContainer,
  ProfileUserDeleteHeadlessModuleDto: ProfileUserDeleteContainer,
  ProfileUserHeaderHeadlessModuleDto: ProfileUserHeaderContainer,
  ProfileUserInformationHeadlessModuleDto: ProfileUserInformationContainer,
  TripChecklistHeadlessModuleDto: TripChecklistContainer,
};

function getProfileModule(
  type: ProfileModule['$type'],
  props: Omit<ProfileModule, '$type'>,
): {
  component: React.ComponentType<Omit<ProfileModule, '$type'>>;
  props: Omit<ProfileModule, '$type'>;
} {
  return { component: ProfileModuleMap[type], props };
}

export interface ProfileModuleListProps {
  /** An array of the modules to show */
  contentModules: ProfileModule[];
}

const ProfileModuleList = ({ contentModules = [] }: ProfileModuleListProps) => {
  return contentModules.map((module, moduleIndex) => {
    const { component: Component, props } = getProfileModule(
      module.$type,
      module,
    );

    if (!Component) return null;

    return <Component key={moduleIndex} {...props} />;
  });
};

ProfileModuleList.displayName = 'ProfileModuleList';

export default ProfileModuleList;
